export default "__VITE_ASSET__Dbp1GcLz__"